import React from "react";
import {Box, CircularProgress, Stack} from "@mui/material";

const LoadingScreen = () => {
    return (
        <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            sx={{
                position: "fixed",
                inset: 0,
                bgcolor: "#fcfbff",
                background: "linear-gradient(145deg, #fcfbff 0%, #f8f6ff 55%, #ffffff 100%)",
                zIndex: 100000,
                overflow: "hidden",
                "&::before": {
                    content: '""',
                    position: "absolute",
                    width: 360,
                    height: 360,
                    borderRadius: "50%",
                    background: "rgba(196, 181, 253, 0.07)",
                    filter: "blur(18px)",
                    top: "18%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                },
            }}
        >
            <Box sx={{position: "relative", display: "flex", alignItems: "center", justifyContent: "center", width: 96, height: 96}}>
                <CircularProgress
                    size={96}
                    thickness={1.8}
                    sx={{
                        position: "absolute",
                        color: "rgba(196, 181, 253, 0.16)",
                        "& .MuiCircularProgress-circle": {
                            stroke: "#c4b5fd",
                            strokeLinecap: "round",
                        },
                    }}
                />
                <Box
                    component="img"
                    src="/logo.svg"
                    alt="OpenBrain"
                    sx={{width: 54, height: 54, objectFit: "contain", position: "relative"}}
                />
            </Box>

        </Stack>
    );
};

export default LoadingScreen;
